<template>
  <div class="home">
    <v-container>
      <v-row v-if="loading" style="justify-content: center; align-content: center; min-height: 277px;">
        <v-progress-circular
          indeterminate
          color="#6c7484"
        ></v-progress-circular>
      </v-row>
      <v-row v-else>
        <v-col cols="12" md="10" offset-md="1">
          <h3 class="h3">Current Status</h3>

          <div v-if="!subscriptions.length" class="status-line d-flex align-center">
            <div class="icon-box success mr-4 d-flex align-center justify-center"><v-icon small color="white">mdi-check</v-icon></div>
            <div class="status-desc">Active</div>
          </div>

          <template v-else>
          <div v-for="subscription in subscriptions" :key="subscription.id" class="status-line d-flex align-center">
            <div :class="`icon-box ${subscriptionClass(subscription)} mr-4 d-flex align-center justify-center`"><v-icon small color="white">{{subscriptionIcon(subscription)}}</v-icon></div>
            <div class="status-desc">{{subscriptionName(subscription)}}</div>
            <v-spacer />
            <div class="status-pricing">{{subscriptionPrice(subscription)}}</div>
          </div>
          </template>

          
          <h3 class="h3 mt-14">Payment Method</h3>

          <template v-if="paymentMethods.length">
            <div v-for="paymentMethod in paymentMethods" :key="paymentMethod.id" class="status-line d-flex align-center">
              <div class="cc-icon mr-4" v-html="paymentCard(paymentMethod)">
              </div>
              <div class="status-desc"><strong>&middot;&middot;&middot;&middot;</strong> {{paymentMethod.card.last4}}</div>
              <v-spacer />
              <div class="status-desc">Expires {{paymentMethod.card.exp_month}}/{{paymentMethod.card.exp_year}}</div>
            </div>
          </template>

          <p>
            <a href="#" class="grey-link" @click.prevent="createPortalSession">Update Payment Information</a>
          </p>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import amex from 'payment-icons/min/flat/amex.svg'
import mastercard from 'payment-icons/min/flat/mastercard.svg'
import discover from 'payment-icons/min/flat/discover.svg'
import visa from 'payment-icons/min/flat/visa.svg'
import defaultCard from 'payment-icons/min/flat/default.svg'

export default {
  name: 'Home',
  data: () => ({
    user: null,
    loading: false,
    paymentMethods: [],
    subscriptions: [],
    products: {},
  }),
  mounted() {
    let comp = this
    const userId = firebase.auth().currentUser.uid
    let userRef = firebase.database().ref('users/' + userId)
    userRef.on('value', snapshot => {
      comp.user = snapshot.val()
    })
    this.getBillingDetails()
  },
  methods: {
    createPortalSession() {
      this.loading = true
      let createFn = firebase.functions().httpsCallable('createPortalSession')
      createFn().then(res => {
        if (res.data && res.data.url) {
          window.location = res.data.url
        } else {
          this.loading = false
          alert('Sorry we had an issue loading your information, please try again')
        }
      })
    },
    getBillingDetails() {
      this.loading = true
      let fn = firebase.functions().httpsCallable('getBillingDetails')
      fn().then(res => {
        console.log(res.data)
        if (res.data) {
          if (res.data.paymentMethods && res.data.paymentMethods.data) {
            this.paymentMethods = res.data.paymentMethods.data
          }
          if (res.data.subscriptions && res.data.subscriptions.data) {
            this.subscriptions = res.data.subscriptions.data
          }
          if (res.data.products && res.data.products.data) {
            res.data.products.data.forEach(product => {
              this.products[product.id] = product
            }) 
          }
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
    subscriptionStatus(subscription) {
      return (subscription.status) ? subscription.status : ''
    },
    subscriptionClass(subscription) {
      const status = this.subscriptionStatus(subscription)
      switch (status) {
        case 'active':
          return 'success'
        case 'canceled':
          return 'error'        
      }
      return 'warning'
    },
    subscriptionIcon(subscription) {
      const cls = this.subscriptionClass(subscription)
      switch (cls) {
        case 'success':
          return 'mdi-check'
        case 'error':
          return 'mdi-close'        
      }
      return 'mdi-dots-horizontal'
    },
    subscriptionName(subscription) {
      if (subscription.items.data[0].price.product && this.products[subscription.items.data[0].price.product]) {
        return this.products[subscription.items.data[0].price.product].name
      }
    },
    subscriptionPrice(subscription) {
      const status = this.subscriptionStatus(subscription)
      if (status !== 'active') {
        return status.toUpperCase().replace('_', ' ')
      }
      if (subscription.items.data[0].price.unit_amount) {
        return '$' + (subscription.items.data[0].price.unit_amount / 100)
      }
    },
    paymentCard(paymentMethod) {
      if (!paymentMethod.card.brand) {
        return `<img src="${defaultCard}" alt="Payment Method">`
      }
      if (paymentMethod.card.brand === 'amex') {
        return `<img src="${amex}" alt="American Express">`
      }
      if (paymentMethod.card.brand === 'discover') {
        return `<img src="${discover}" alt="Discover">`
      }
      if (paymentMethod.card.brand === 'mastercard') {
        return `<img src="${mastercard}" alt="MasterCard">`
      }
      if (paymentMethod.card.brand === 'visa') {
        return `<img src="${visa}" alt="VISA">`
      }
      return `<img src="${defaultCard}" alt="Payment Method">`
    }
  },
}
</script>

<style>
.cc-icon img {
  width:40px;
  display: block;
}
</style>
<style scoped>
.h3 {
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: bold;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: solid 1px #DCE2EA;
}
.home {
  text-align: left;
  padding: 2rem 0;
}
.icon-box {
  text-align: center;;
  height: 24px;
  line-height: 24px;
  width: 24px;
  border-radius: 4px;
}
.status-line {
  margin-bottom: 1rem;
}
.status-desc,
.status-pricing {
  font-size: 16px;
  color: var(--v-secondary-base);
}
.status-pricing {
  font-weight: bold;
}
a.grey-link {
  color: #6c7484!important;
  text-decoration: none;
}
a.grey-link:hover {
  text-decoration: underline;
}
</style>
